export enum RevenueCalculationStrategy {
  revenue = "revenue",
  revenueExcludingTaxes = "revenueExcludingTaxes",
  revenueExcludingSourceDetails = "revenueExcludingSourceDetails",
  revenueExcludingTaxesAndSourceDetails = "revenueExcludingTaxesAndSourceDetails",
}
